import { Box, Paper, Stack, Typography } from "@mui/material";
import { SidebarActionItem } from "../types/sidebar.types";
import { KeyboardArrowRightRounded } from "@mui/icons-material";

interface Props {
  item: SidebarActionItem;
}

export default function SidebarActionItemCard({ item }: Props) {
  return (
    <Paper
      onClick={item.onClick}
      sx={{
        borderRadius: "12px",
        p: 1,
        boxShadow: 0,
        cursor: item.onClick ? "pointer" : "default",
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Box
          sx={{
            width: 45,
            height: 45,
            borderRadius: "50%",
            bgcolor: "#f0f4f8",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {item.icon}
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "13px",
              lineHeight: 1.5,
            }}
          >
            {item.title}
          </Typography>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "11px",
              color: "#cbd5e1",
              lineHeight: 1.5,
            }}
          >
            {item.subtitle}
          </Typography>
        </Box>
        <KeyboardArrowRightRounded
          sx={{ fontSize: 18, color: "#cbd5e1", flexShrink: 0 }}
        />
      </Stack>
    </Paper>
  );
}
